import { useContext } from "react";
import { SessionContext } from "./SessionProvider";

/**
 * Hook conveniente para leer el state de la sesión desde cualquier
 * componente descendiente de <SessionProvider>.
 *
 * Devuelve todo lo que useResearchSession() expone: sessionId, step,
 * formData, responses, loading, error, runDiscovery, etc.
 *
 * Lanza error claro si se usa fuera del Provider (bug-finding helper).
 */
export function useSession() {
  const ctx = useContext(SessionContext);
  if (!ctx) {
    throw new Error("useSession() debe usarse dentro de <SessionProvider>");
  }
  return ctx;
}
